import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { X } from "@phosphor-icons/react";
import { PLATFORM_BY_KEY } from "../../platforms";

// Read-only side panel: full JSON returned for a single platform preview + AI metadata.
export function PreviewDetailPanel({ preview, onClose }) {
  const { t } = useTranslation();
  if (!preview) return <AnimatePresence />;
  const meta = PLATFORM_BY_KEY[preview.platform] || {};
  const Field = ({ label, value }) => value == null || value === "" ? null : (
    <div><div className="promo-overline">{label}</div><div className="mt-1 break-words text-sm font-medium">{value}</div></div>
  );
  return (
    <AnimatePresence>
      {preview && (
        <div className="fixed inset-0 z-[60]" data-testid="preview-detail-panel">
          <motion.div className="absolute inset-0 bg-background/70 backdrop-blur-sm" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} />
          <motion.aside className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col border-l border-border bg-card"
            initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "tween", duration: 0.25 }}>
            <div className="flex items-center justify-between border-b border-border px-5 py-4">
              <div className="flex items-center gap-2">{meta.Icon && <meta.Icon size={16} />}<span className="promo-overline">{meta.label || preview.platform}</span></div>
              <button onClick={onClose} className="rounded-md p-1 text-muted-foreground hover:bg-accent" data-testid="preview-panel-close"><X size={18} /></button>
            </div>
            <div className="flex-1 space-y-5 overflow-y-auto p-5">
              <div className="grid grid-cols-2 gap-4">
                <Field label={t("promo.preview.f.provider")} value={preview.provider} />
                <Field label={t("promo.preview.f.prompt")} value={preview.prompt_key ? `${preview.prompt_key}${preview.prompt_version ? ` v${preview.prompt_version}` : ""}` : null} />
                <Field label={t("promo.preview.f.kb")} value={preview.knowledge_base ? (preview.knowledge_base.name || preview.knowledge_base.id || "—") : null} />
              </div>
              {Array.isArray(preview.citations) && preview.citations.length > 0 && (
                <div>
                  <div className="promo-overline mb-2">{t("promo.preview.f.citations")}</div>
                  <div className="space-y-1.5">
                    {preview.citations.map((c, i) => (
                      <div key={i} className="rounded-md border border-border bg-accent/20 px-2.5 py-1.5 text-xs text-muted-foreground">
                        {typeof c === "string" ? c : (c.title || c.source || JSON.stringify(c))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div>
                <div className="promo-overline mb-2">{t("promo.preview.f.json")}</div>
                <pre className="overflow-x-auto rounded-lg border border-border bg-accent/20 p-3 font-mono text-[11px] leading-relaxed text-foreground/90" data-testid="preview-json">
{JSON.stringify(preview, null, 2)}
                </pre>
              </div>
            </div>
          </motion.aside>
        </div>
      )}
    </AnimatePresence>
  );
}
